import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import BiSectionLayout from '../components/biSectionLayout';
import ProtectedRoute from '../components/protectedRoutes';
import AcordosBIGE from '../pages/biGE/acordos';
import InadimplenciaBIGE from '../pages/biGE/inadimplencia';
import ListaInadimplentesBIGE from '../pages/biGE/listaInadimplentes';
import ListaSerasaBIGE from '../pages/biGE/listaSerasa';
import SituacaoInadimplentesBIGE from '../pages/biGE/situacaoInadimplentes';
import DashboardCobranca from '../pages/biCOB/dashboardCobranca';

const RouteBICOB = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='BICOB'/>}>
                <Route element={<BiSectionLayout sectionKey='bi-cobranca'/>}>
                    <Route index element={<Navigate to='dashboard' replace/>}/>
                    <Route path='dashboard' element={<DashboardCobranca/>}/>
                    <Route path='inadimplencia' element={<InadimplenciaBIGE/>}/>
                    <Route path='inadimplencia/lista' element={<ListaInadimplentesBIGE/>}/>
                    <Route path='acordos' element={<AcordosBIGE/>}/>
                    <Route path='listaSerasa' element={<ListaSerasaBIGE/>}/>
                    <Route path='situacaoInadimplentes' element={<SituacaoInadimplentesBIGE/>}/>
                </Route>
            </Route>
        </Routes>
    );
};

export default RouteBICOB;
